module.exports = __webpack_public_path__ + "media/office_background_noise.bb9f60fb.wav";